export enum DeliveryStatusListView {
  Inspection = 'Inspection',
}
